import * as d3 from "d3";
import _ from "lodash";
import $ from "jquery";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Button, Card, Divider, Header, Icon, Input, Label, Segment } from "semantic-ui-react";
import { restRequest } from "../../http";
import { MeasurementPlotLimitData, MeasurementPlotResultData, PlotData, UpdateLimitData, UpdateLimitMeasurementData, UpdateLimitTestData } from "../../models/update_limit_model";
import { untilStable } from "../../utils";
import { PlotChannelColors } from "../../models/common_model";

const statusColors = ['', PlotChannelColors[0], 'darkred'];
export function UpdateLimitPlotConponent(props: { match: any }) {
    const id = props.match.params.id - 0;

    const [data, setData] = useState<UpdateLimitMeasurementData>();
    const [channels, setChannels] = useState<number[]>([]);
    const [selectedChannel, setSelectedChannel] = useState(1);
    const [selectedCriterionIndex, setSelectedCriterionIndex] = useState<number>(0);
    const [selectedOriginalLimitIndex, setSelectedOriginalLimitIndex] = useState<number>(0);
    const [selectedTestResultIndex, setSelectedTestResultIndex] = useState<number>(0);
    const [selectedCalculateResultIndex, setSelectedCalculateResultIndex] = useState<number>(0);
    const [selectedStatuses, setSelectedStatuses] = useState<boolean[]>([true, true]);
    const [selectedUpdateLimitStatuses, setSelectedUpdateLimitStatuses] = useState<boolean[]>([true, true]);
    const [serialNumberKeyword, setSerialNumberKeyword] = useState('')
    const [loading, setLoading] = useState(false);
    const [plotData, setPlotData] = useState<PlotData>();
    const [resultData, setResultData] = useState<(MeasurementPlotResultData & { is_pass_limit?: boolean })[]>([]);
    const [selectedResultData, setSelectedResultData] = useState<(MeasurementPlotResultData & { is_pass_limit?: boolean })[]>([]);
    const [forSelectResultData, setForSelectResultData] = useState<(MeasurementPlotResultData & { is_pass_limit?: boolean })[]>([]);
    const [forSelectSelectedResultData, setForSelectSelectedResultData] = useState<(MeasurementPlotResultData & { is_pass_limit?: boolean })[]>([]);
    const [originalLimitData, setOriginalLimitData] = useState<MeasurementPlotLimitData[]>();
    const [updateLimitData, setUpdateLimitData] = useState<UpdateLimitData>();
    const [updateLimitTestData, setUpdateLimitTestData] = useState<UpdateLimitTestData>();
    const svgRootRef = useRef<HTMLDivElement>(null);
    const [canvasSize, setCanvasSize] = useState([0, 0]);
    const canvasContextRef = useRef<CanvasRenderingContext2D>();
    const operationContextRef = useRef<CanvasRenderingContext2D>();
    const xRef = useRef<d3.ScaleLogarithmic<number, number, never>>();
    const yRef = useRef<d3.ScaleLinear<number, number, never>>();
    const limitLineRef = useRef<d3.Line<number>>();
    const resultLineRef = useRef<d3.Line<number>>();
    const [dataReady, setDataReady] = useState(false);
    const [canvasReady, setCanvasReady] = useState(false);
    const [mouseXY, setMouseXY] = useState<number[]>([0, 0]);
    const margin = ({ top: 20, right: 30, bottom: 30, left: 50 });

    useLayoutEffect(() => {
        const onResize = function () {
            if (svgRootRef.current) {
                const offset = $(svgRootRef.current).offset()!;
                const width = $(svgRootRef.current).innerWidth()!;

                setCanvasSize([width - 20, window.innerHeight - offset.top - 40]);
            }
        };

        $(window).on('resize', onResize);
        onResize();

        return () => {
            $(window).off('resize', onResize);
        }

    }, []);

    useEffect(() => {
        restRequest<UpdateLimitMeasurementData>(`update_limit/measurements/${id}`).then(data => {
            setData(data);
            setChannels(_.keys(data.results[_.keys(data.results)[0]].limits[data.calculate_result_keys[0]]).map(c => parseInt(c)).sort());
        });
    }, []);

    useEffect(() => {
        if (!data) {
            return;
        }

        setLoading(true);
        const key = data?.test_result_keys[selectedTestResultIndex];
        restRequest<PlotData>(`update_limit/measurements/${id}/result_data`, { key, channel: selectedChannel }, 'post').then(data => {
            setPlotData(data);
        }).finally(() => setLoading(false));
    }, [data, selectedChannel, selectedTestResultIndex]);

    useEffect(() => {
        if (data) {
            setUpdateLimitData(data.results[data.criteria_keys[selectedCriterionIndex]].limits[data.calculate_result_keys[selectedCalculateResultIndex]][selectedChannel])
        }
    }, [data, selectedChannel, selectedCriterionIndex, selectedCalculateResultIndex]);

    useEffect(() => {
        if (data) {
            setUpdateLimitTestData(data.results[data.criteria_keys[selectedCriterionIndex]].tests[data.calculate_result_keys[selectedCalculateResultIndex]][data.test_result_keys[selectedTestResultIndex]][selectedChannel])
        }
    }, [data, selectedChannel, selectedCriterionIndex, selectedCalculateResultIndex, selectedTestResultIndex]);

    useEffect(() => {
        if (plotData && updateLimitData && updateLimitTestData) {
            let results: (MeasurementPlotResultData & { is_pass_limit?: boolean })[] = plotData.results;
            if (serialNumberKeyword) {
                results = results.filter(r => r.serial_number.includes(serialNumberKeyword))
            }

            if (results.length > 0 && selectedStatuses.length != selectedStatuses.filter(s => s).length) {
                if (selectedStatuses[0]) {
                    // pass
                    results = results.filter(r => r.status === 1);
                } else if (selectedStatuses[1]) {
                    // fail
                    results = results.filter(r => r.status === 2);
                } else {
                    results = []
                }
            }

            if (results.length > 0 && selectedUpdateLimitStatuses.length !== selectedUpdateLimitStatuses.filter(s => s).length) {
                if (selectedUpdateLimitStatuses[0]) {
                    // pass
                    results = plotData.results.filter(r => updateLimitTestData.pass_file_ids.includes(r.file_id))
                } else if (selectedUpdateLimitStatuses[1]) {
                    // fail
                    results = plotData.results.filter(r => updateLimitTestData.fail_file_ids.includes(r.file_id))
                } else {
                    results = []
                }
            }

            results = results.map(r => ({ ...r, is_pass_limit: updateLimitTestData.pass_file_ids.includes(r.file_id) }))

            setResultData(results);
        }
    }, [plotData, selectedUpdateLimitStatuses, selectedStatuses, updateLimitData, updateLimitTestData, serialNumberKeyword]);

    useEffect(() => {
        setCanvasReady(false);

        if (!resultData || !updateLimitTestData) {
            return;
        }

        return untilStable<number>(() => svgRootRef.current!.offsetWidth, (svgWidth) => {
            let canvas = d3.select(svgRootRef.current!).select<HTMLCanvasElement>('canvas.base');
            let operationCanvas = d3.select(svgRootRef.current!).select<HTMLCanvasElement>('canvas.operation');

            if (canvas.size() === 0) {
                canvas = d3.select(svgRootRef.current!)
                    .append("canvas")
                    .attr('class', 'base');

                operationCanvas = d3.select(svgRootRef.current!)
                    .append("canvas")
                    .attr('class', 'operation')
                    .style('background', 'rgba(255,255,255,0)')
                    .style('position', 'absolute')
                    .style('z-index', '1')
                    .style('top', '0')
                    .style('left', '0');
            }

            canvas.attr("width", canvasSize[0]).attr("height", canvasSize[1]);
            operationCanvas.attr("width", canvasSize[0]).attr("height", canvasSize[1]);
            canvasContextRef.current = canvas.node()!.getContext('2d')!;
            operationContextRef.current = operationCanvas.node()!.getContext('2d')!;

            const yDomain = yRef.current?.domain();
            const yRange = yRef.current?.range();

            const miniY = yDomain && yRange ? Math.abs((yDomain[1] - yDomain[0]) * 2 / (yRange[1] - yRange[0])) : 2;

            const bisectDate = d3.bisector<number, number>(function (d) { return d }).left;

            const x_values = updateLimitTestData.x_values

            let currentSelectedVectorData: MeasurementPlotResultData[] = [];
            setForSelectResultData([]);
            operationCanvas.on('mouseover', function () {
                //todo hide cursor lines
            })
                .on('mouseout', function () {
                    setMouseXY([0, 0]);
                    setSelectedResultData([]);
                })
                .on('mousemove', function (event) {
                    if (resultData && xRef.current && yRef.current) {
                        const mouse = d3.pointer(event);
                        const mouseX = xRef.current.invert(mouse[0] - margin.left);
                        const mouseY = yRef.current.invert(mouse[1] - margin.top);

                        const selectedUnits: [number, MeasurementPlotResultData][] = [];
                        resultData.forEach((d, index) => {
                            let i = bisectDate(x_values, mouseX);
                            if (i < x_values.length) {
                                if (i > 0 && mouseX - x_values[i - 1] < x_values[i] - mouseX) {
                                    i -= 1;
                                }

                                const yDiff = Math.abs(d.y_values[i] - mouseY);
                                if (yDiff < miniY) {
                                    selectedUnits.push([yDiff, d])
                                }
                            }
                        });

                        const selectedVectorData = selectedUnits.sort((a, b) => a[0] > b[0] ? 1 : (a[0] === b[0] ? 0 : -1)).slice(0, 10).map(s => s[1]);
                        setMouseXY([mouseX, mouseY]);
                        setSelectedResultData(selectedVectorData);

                        currentSelectedVectorData = selectedVectorData;
                    }
                }).on('click', function () {
                    setForSelectResultData(currentSelectedVectorData);
                    setForSelectSelectedResultData([]);
                });

            setCanvasReady(true);
        }, 200);
    }, [resultData, updateLimitTestData]);

    useEffect(() => {
        const operationContext = operationContextRef.current;
        if (operationContext && canvasSize[0] !== 0 && selectedResultData && forSelectResultData) {
            operationContext.clearRect(0, 0, canvasSize[0], canvasSize[1]);
            if (resultLineRef.current) {
                const line = resultLineRef.current.context(operationContext);
                operationContext.save();
                operationContext.translate(margin.left, margin.top);
                for (const d of _.uniq(selectedResultData.concat(forSelectResultData))) {
                    operationContext.beginPath();
                    line(d.y_values);
                    operationContext.lineWidth = 1;
                    operationContext.strokeStyle = 'yellow';
                    operationContext.stroke();
                }
                operationContext.restore();
            }
        }
    }, [selectedResultData, forSelectSelectedResultData]);

    useEffect(() => {
        if (canvasSize[0] == 0 || !resultData || !updateLimitData || !updateLimitTestData || !canvasReady) {
            return;
        }

        const [fullWidth, fullHeight] = canvasSize;
        const context = canvasContextRef.current!;
        context.clearRect(0, 0, fullWidth, fullHeight);

        const width = fullWidth - margin.left - margin.right;
        const height = fullHeight - margin.top - margin.bottom;

        const limitXValues = updateLimitData.x_values;
        const resultXValues = updateLimitTestData.x_values;


        const xDomain = d3.extent(limitXValues.concat(resultXValues)) as number[];
        const yDomain = d3.extent(_.flatten(resultData.map(d => d3.extent(d.y_values))).concat(d3.extent(updateLimitData.lower_y_values)).concat(d3.extent(updateLimitData.upper_y_values)) as number[]) as number[];
        const x = d3.scaleLog().domain(xDomain).range([margin.left, width - margin.right]);
        xRef.current = x;
        const xAxis = () => {
            const tickCount = 10,
                tickSize = 6,
                ticks = x.ticks(tickCount),
                tickFormat = x.tickFormat(tickCount, 'd');

            context.beginPath();
            ticks.forEach(function (d) {
                context.moveTo(x(d), height);
                context.lineTo(x(d), 0);
            });
            context.strokeStyle = "gray";
            context.stroke();

            const xAxisTitle = xDomain[xDomain.length - 1] >= 1500 ? 'Frequency(Hz)' : '';
            context.beginPath();
            context.strokeStyle = "black";
            const metrics = context.measureText(xAxisTitle);
            const textWidth = metrics.width;
            context.fillText(xAxisTitle, x(xDomain[0]) + x(xDomain[1]) / 2 - x(xDomain[0]) / 2 - textWidth / 2, fullHeight - 30);

            context.beginPath();
            context.lineTo(0, height - tickSize);
            context.lineTo(width, height - tickSize);
            context.strokeStyle = "gray";
            context.stroke();

            context.textAlign = "center";
            context.textBaseline = "top";
            ticks.forEach(function (d) {
                context.fillText(tickFormat(d), x(d), height);
            });
        }

        const y = d3.scaleLinear().domain(yDomain).range([height - margin.bottom, margin.top]);
        yRef.current = y;

        const yAxis = () => {
            const tickCount = 10,
                tickSize = 6,
                tickPadding = 3,
                ticks = y.ticks(tickCount),
                tickFormat = y.tickFormat(tickCount);

            context.beginPath();
            ticks.forEach(function (d) {
                context.moveTo(0, y(d));
                context.lineTo(width, y(d));
            });
            context.strokeStyle = "black";
            context.stroke();

            context.beginPath();
            context.moveTo(-tickSize, 0);
            context.lineTo(0.5, 0);
            context.lineTo(0.5, height);
            context.lineTo(-tickSize, height);
            context.strokeStyle = "black";
            context.stroke();

            context.textAlign = "right";
            context.textBaseline = "middle";
            ticks.forEach(function (d) {
                context.fillText(tickFormat(d), -tickSize - tickPadding, y(d));
            });

            const yAxisTitle = data?.measurement_key.split('_le-witt_')[1] || '';
            context.save();
            context.rotate(-Math.PI / 2);
            context.textAlign = "right";
            context.textBaseline = "top";
            context.strokeStyle = "black";
            const metrics = context.measureText(yAxisTitle);
            const textWidth = metrics.width;
            context.fillText(yAxisTitle, -(height / 2) + textWidth / 2, -margin.left);
            context.restore();
        }

        const baseLimitLine = d3.line<number>()
            .x(function (d: number, i: number) { return x(limitXValues[i]) })
            .y(function (d: number, i: number) { return y(d) });

        const baseResultLine = d3.line<number>()
            .x(function (d: number, i: number) { return x(resultXValues[i]) })
            .y(function (d: number, i: number) { return y(d) });

        limitLineRef.current = baseLimitLine;
        resultLineRef.current = baseResultLine;

        const limitLine = baseLimitLine.context(context);
        const resultLine = baseResultLine.context(context);

        context.save();
        context.translate(margin.left, margin.top);
        xAxis();
        yAxis();

        resultData.forEach((r, index) => {
            context.beginPath();
            resultLine(r.y_values);
            context.lineWidth = 1;
            context.strokeStyle = statusColors[r.is_pass_limit ? 1 : 2];
            context.stroke();
        });

        context.beginPath();
        limitLine(updateLimitData.lower_y_values);
        context.lineWidth = 3;
        context.strokeStyle = "#FF0000";
        context.stroke();

        context.beginPath();
        limitLine(updateLimitData.upper_y_values);
        context.lineWidth = 3;
        context.strokeStyle = "#FF0000";
        context.stroke();

        context.restore();

        return () => {
            context.clearRect(0, 0, fullWidth, fullHeight);
        }

    }, [resultData, updateLimitData, updateLimitTestData, canvasSize, canvasReady]);

    return <div style={{ padding: '0 1rem' }}>
        <Header attached="top">{data?.measurement_key.split('_le-witt_')[0]} <sub>{data?.measurement_key.split('_le-witt_')[1]}</sub></Header>
        <Segment attached="bottom" compact basic style={{ padding: '0', margin: '0' }} loading={loading}>
            <Segment.Group horizontal={true} compact style={{ padding: '2px', margin: '0', border: 'none' }}>
                <Segment style={{ width: '250px', flex: 'inherit' }}>
                    {channels.length > 1 && <Card>
                        <Card.Header textAlign="center">Channels</Card.Header>
                        <Card.Content>
                            <Button.Group compact vertical>
                                {channels.map(c => <Button key={c} secondary basic={selectedChannel !== c} onClick={e => {
                                    setSelectedChannel(c);
                                }}>CH{c}</Button>)}
                            </Button.Group>
                        </Card.Content>
                    </Card>}
                    <Card>
                        <Card.Header textAlign="center">Limit by Calculate Result</Card.Header>
                        <Card.Content>
                            <Button.Group compact vertical fluid>
                                {data?.calculate_results.map((cr, i) => <Button key={i} secondary basic={selectedCalculateResultIndex !== i} onClick={e => {
                                    setSelectedCalculateResultIndex(i);
                                }}>{cr.name}</Button>)}
                            </Button.Group>
                        </Card.Content>
                    </Card>

                    <Card>
                        <Card.Header textAlign="center">Limit by Criteria</Card.Header>
                        <Card.Content>
                            <Button.Group compact vertical>
                                {data?.criteria.map((c, i) => <Button key={i} secondary basic={selectedCriterionIndex !== i} onClick={e => {
                                    setSelectedCriterionIndex(i);
                                }}>{c.name}</Button>)}
                            </Button.Group>
                        </Card.Content>
                    </Card>

                    <Card>
                        <Card.Header textAlign="center">Test Result</Card.Header>
                        <Card.Content>
                            <Button.Group compact vertical fluid>
                                {data?.test_results.map((tr, i) => <Button key={i} secondary basic={selectedTestResultIndex !== i} onClick={e => {
                                    setSelectedTestResultIndex(i);
                                }}>{tr.name}</Button>)}
                            </Button.Group>
                        </Card.Content>
                    </Card>

                    <Card>
                        <Card.Header textAlign="center">Test Result to Limit</Card.Header>
                        <Card.Content>
                            <Button.Group compact vertical fluid>
                                {['Pass', 'Fail'].map((s, i) => <Button key={i} secondary basic={!selectedUpdateLimitStatuses[i]} onClick={e => {
                                    setSelectedUpdateLimitStatuses(s => {
                                        s[i] = !s[i]
                                        return [...s];
                                    });
                                }}>{s}</Button>)}
                            </Button.Group>
                        </Card.Content>
                    </Card>

                    <Card>
                        <Card.Header textAlign="center">Test Result Status</Card.Header>
                        <Card.Content>
                            <Button.Group compact vertical fluid>
                                {['Pass', 'Fail'].map((s, i) => <Button key={i} secondary basic={!selectedStatuses[i]} onClick={e => {
                                    setSelectedStatuses(s => {
                                        s[i] = !s[i]
                                        return [...s];
                                    });
                                }}>{s}</Button>)}
                            </Button.Group>
                        </Card.Content>
                    </Card>

                    <Divider></Divider>
                    <Header attached="top" size="tiny">Selected</Header>
                    <Segment attached="bottom" size="tiny">
                        <div>
                            X: {mouseXY[0]}<br />
                            Y: {mouseXY[1]}
                        </div>

                        <Divider></Divider>
                        <div className="button_container">
                            {selectedResultData.map(d => <Label key={_.last(d.file_path.split('/'))} size="tiny" basic style={{ color: statusColors[d.is_pass_limit ? 1 : 2] }}>{d.serial_number}</Label>)}
                        </div>

                        <Divider></Divider>
                        <div className="button_container">
                            {forSelectResultData.map(d => <Button style={{ opacity: forSelectSelectedResultData.includes(d) ? 1 : 0.314, background: statusColors[d.status], color: '#fff' }} onClick={e => {
                                e.preventDefault();
                                if (forSelectSelectedResultData.includes(d)) {
                                    setForSelectSelectedResultData(vs => vs.filter(v => v !== d));
                                } else {
                                    setForSelectSelectedResultData(vs => [...vs, d]);
                                }
                            }} key={d.file_id} size="mini" compact title={d.file_path}>{d.serial_number}</Button>)}
                        </div>
                    </Segment>

                    <Divider></Divider>

                    <Header attached="top">
                        <Input icon placeholder='Search By Serial...' size="small">
                            <input value={serialNumberKeyword} onChange={e => setSerialNumberKeyword(e.target.value)} />
                            <Icon name='search' />
                        </Input>
                    </Header>
                    <Segment attached="bottom" size="tiny">
                        <div className="button_container">
                            {selectedResultData.map(d => <Button key={d.file_id} onClick={e => {
                                e.preventDefault();

                                let contains = false;
                                if (forSelectSelectedResultData.includes(d)) {
                                    setForSelectSelectedResultData(vs => vs.filter(v => v !== d));
                                    contains = true;
                                }

                                if (selectedResultData.includes(d)) {
                                    setSelectedResultData(vs => vs.filter(v => v !== d));
                                    contains = true;
                                }

                                if (!contains) {
                                    setForSelectSelectedResultData(vs => [...vs, d]);
                                }

                            }} style={{ opacity: (forSelectSelectedResultData.includes(d) || selectedResultData.includes(d)) ? 1 : 0.314, background: statusColors[d.status], color: '#fff' }} title={d.file_path} size="mini" compact>{d.serial_number}</Button>)}
                        </div>
                    </Segment>
                </Segment>
                <Segment>
                    <div style={{ float: 'right', position: 'relative', width: `100%` }} ref={svgRootRef}></div>
                </Segment>
            </Segment.Group>
        </Segment>
    </div>
}